import FindResourceEntryInteractor from "../../core/interactor/app/crud/FindResourceEntryInteractor";
import Constants from "../../caseLawDocuments/common/Constants";
import { IInstitutionDetails } from "../model/InstitutionDetails";
import InstitutionDetailsMapper from "../service/InsitutionDetailsMapper";
import InstitutionDetailsParamMapper from "../service/InstitutionDetailsParamMapper";

export default class GetInstitutionDetailsInteractor {
  private resource: FindResourceEntryInteractor<IInstitutionDetails>;

  constructor({ findResourceEntry }: any) {
    this.resource = findResourceEntry;
  }

  async execute(id: number) {
    return this.resource.execute(
      `${Constants.organisationsPath}/institution-details`,
      InstitutionDetailsMapper,
      InstitutionDetailsParamMapper,
      id
    );
  }
}
